import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { css } from "styled-components";
import { getThemeData, createStyleComponent } from "@hzero-front-ui/core";
var getProgressCss = function getProgressCss(props) {
  var _getThemeData = getThemeData(props, "common"),
    primary = _getThemeData.primary;
  var _getThemeData2 = getThemeData(props, "circleProgress"),
    execBgColor = _getThemeData2.execBgColor,
    succBgColor = _getThemeData2.succBgColor;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    /* \u52A0\u8F7D\u4E2Dcircle */\n    .c7n-progress.c7n-progress-loading {\n      &.c7n-progress-status-normal circle {\n        stroke: ", ";\n      }\n      &.c7n-progress-status-exception circle {\n        stroke: ", ";\n      }\n      &.c7n-progress-status-success circle {\n        stroke: ", ";\n      }\n    }\n  "])), primary, execBgColor, succBgColor);
};
export default createStyleComponent("comp/progress", getProgressCss);